import { z } from 'zod';

import { ukPhoneRegex } from '@/lib/forms/validation';

export type EnquirySchemaOptions = {
  includePreferredContact?: boolean;
  messageMax?: number;
  messageMin?: number;
  fullNameMin?: number;
  fullNameMax?: number;
  phoneMin?: number;
  phoneMax?: number;
  useUkPhoneRegex?: boolean;
};

export function createEnquirySchema(options: EnquirySchemaOptions = {}) {
  const {
    includePreferredContact = true,
    messageMax = 2000,
    messageMin = 1,
    fullNameMin = 1,
    fullNameMax = 120,
    phoneMin = 1,
    phoneMax = 40,
    useUkPhoneRegex = false,
  } = options;

  const fullName = z
    .string()
    .trim()
    .min(fullNameMin, 'Full name is required')
    .max(fullNameMax, 'Full name is too long');

  const email = z
    .string()
    .trim()
    .min(1, 'Email is required')
    .email('Please enter a valid email')
    .max(160, 'Email is too long');

  const phone = useUkPhoneRegex
    ? z
        .string()
        .trim()
        .min(phoneMin, 'Phone number is required')
        .regex(ukPhoneRegex, 'Please enter a valid UK phone number.')
    : z
        .string()
        .trim()
        .min(phoneMin, 'Phone number is required')
        .max(phoneMax, 'Phone number is too long');

  const message = z
    .string()
    .trim()
    .min(messageMin, 'Message is required')
    .max(messageMax, 'Message is too long');

  const preferredContact = includePreferredContact
    ? z.enum(['phone', 'email', 'whatsapp'])
    : z.enum(['phone', 'email', 'whatsapp']).optional();

  return z.object({
    fullName,
    email,
    phone,
    preferredContact,
    message,
  });
}

export const defaultEnquirySchema = createEnquirySchema();
